export default "__VITE_ASSET__00faad13__"